import strFunc from '@/lib/lyg/string';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function SearchArea(props: any) {
  let myProps = {
    listOpt:{},
    list:(inData:any)=>{},
    closePopup:()=>{},
    subject_main_info_arr:[],
    ...props
  };
  let listOpt=myProps.listOpt;
  let select_subject_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });
  let subject_main_info_arr=myProps.subject_main_info_arr;

  const on_change_search_input=(inData:any)=>{
    let name=inData.target.name;
    let value=inData.target.value;
    let change_list_opt:any={};
    change_list_opt[name]=value;
    myProps.list({
      now_page:"1",
      ...change_list_opt
    });
  };

  return (
    <div className="btn-box-center m-2">
      <select className="search-input" name="s_sort" value={listOpt.s_sort} 
        onChange={on_change_search_input} >
          <option value="">전체</option>
        {select_subject_option_arr.map((item: any, idx: number) => {
          return (
            <option key={idx} value={item.value}>{item.text}</option>
          );
        })}
      </select>
      <select className="search-input ml-1" name="s_main_seq" value={listOpt.s_main_seq} 
        onChange={on_change_search_input}>
          <option value="">전체</option>
          {subject_main_info_arr.map((item:any,idx:number)=>{
            if(!strFunc.is_empty(listOpt.s_sort)){
              if(listOpt.s_sort!=item.a_subject_sort){
                return "";
              }
            }
            return (
              <option key={idx} value={item.a_seq}>{item.a_title}</option>
            );
          })}
      </select>
      <button className="btn btn-dark" onClick={()=>{myProps.list({});}}>검색</button>
    </div>
  );
};
export default SearchArea;